import { Stack, Avatar } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { getAbbreviation, cutString } from 'app-zephyr-utils';
import { PinnedIcon, PinIcon, CheckmarkIcon } from 'app-zephyr-icons';

import { BreadcrumbType } from './interfaces';
import { useStyles } from './styles';

export function DropDownListItem({
  selectedItem,
  name,
  type,
  isPinned,
  onNavigateClick,
  onPinClick,
  onSelectClick,
}: {
  selectedItem?: string;
  type: BreadcrumbType;
  isPinned: boolean;
  name: string;
  onNavigateClick: () => void;
  onSelectClick: () => void;
  onPinClick: () => void;
}) {
  const { classes, theme } = useStyles();

  return (
    <Stack
      data-e2e={`breadcrumb-filter-${type}-item`}
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      gap={1}
      className={classes.itemContent}
      onClick={onNavigateClick}
    >
      <Stack direction={'row'} alignItems={'center'} gap={1}>
        {type === BreadcrumbType.ORGANIZATION && (
          <Avatar
            alt={'avatar'}
            sx={{
              backgroundColor: theme.palette.brand.gray[300],
              fontSize: '12px',
              width: '24px',
              height: '24px',
            }}
          >
            {getAbbreviation(name)}
          </Avatar>
        )}
        <span className={classes.itemName}>{cutString(17, name)}</span>
      </Stack>

      <Stack direction={'row'} alignItems={'center'} gap={1}>
        {type !== BreadcrumbType.APPLICATION && (
          <Stack
            data-e2e={`breadcrumb-filter-${type}-pin-icon`}
            justifyContent={'center'}
            onClick={(event) => {
              event.stopPropagation();
              onPinClick();
            }}
          >
            {isPinned ? <PinnedIcon /> : <PinIcon />}
          </Stack>
        )}

        {selectedItem === name && <CheckmarkIcon color="#AE87F6" width={24} height={24} />}
        {selectedItem !== name && type !== BreadcrumbType.APPLICATION && (
          <Stack
            justifyContent={'center'}
            onClick={(event) => {
              event.stopPropagation();
              onSelectClick();
            }}
          >
            <KeyboardArrowDownIcon
              data-e2e={`breadcrumb-filter-${type}-arrow-icon`}
              sx={{ fill: '#646464', transform: 'rotate(-90deg)' }}
              width={8}
              height={10}
            />
          </Stack>
        )}
        {type === BreadcrumbType.APPLICATION && (
          <Stack
            data-e2e={`breadcrumb-filter-${type}-pin-icon`}
            justifyContent={'center'}
            onClick={(event) => {
              event.stopPropagation();
              onPinClick();
            }}
          >
            {isPinned ? <PinnedIcon /> : <PinIcon />}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
